import React from 'react';

const PermitDesktopInstruction = () => (
	<span>
        <h2 className="mic-permission-title">This question requires you to record your answer(s).</h2>
        <p className="mic-permission-subtitle">Please follow the instructions to enable your microphone permission:</p>
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="instruction-tips"><span>1</span>Go to the address bar in the Chrome browser.</div>
                <div className="instruction-tips"><span>2</span>Click the camera icon with the X.</div>
                <div className="instruction-tips"><span>3</span>Click Always allow {window.location.protocol}{'//'}{window.location.hostname} to access your microphone.</div>
                <div className="instruction-tips"><span>4</span>Click Done.</div>
                <div className="instruction-tips"><span>5</span>Click Reload.</div>
            </div>
        </div> 
    </span>
)


export default PermitDesktopInstruction;